module.exports = __webpack_public_path__ + "img/btnCard-5.03e20eb1.jpg";